import { Product } from './product.model';

// djb:refactor-extremely confusing use of polymorphism
// needs serious refactoring (note the following compiler directive)
// djb:yagni-tslint:disable:unified-signatures

type PackageBuilderModelLike = { wheel: Product, labours: Product[] }
  | { tire: Product, labours: Product[] }
  | { hardwares: Product[], labours: Product[] }
  | { wheel: Product }
  | { tire: Product }
  | { hardwares: Product[] };

export class PackageBuilderModel {
  public wheel: Product;
  public tire: Product;
  public hardwares: Product[] = [];
  public labours: Product[] = [];

  constructor();
  constructor(obj: PackageBuilderModel);
  constructor(obj: { wheel: Product, labours: Product[]});
  constructor(obj: { tire: Product, labours: Product[]});
  constructor(obj: { hardwares: Product[], labours: Product[]});
  constructor(obj: { wheel: Product });
  constructor(obj: { tire: Product });
  constructor(obj: { hardwares: Product[] });

  constructor(obj?: PackageBuilderModel | PackageBuilderModelLike) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
